import { useRequesterStore } from '../stores/requester'

let requesterX: any

export interface UpdateUserPayload {
  name: string
  fullname: string
  phone: string
}

export async function updateUser(user: UpdateUserPayload) {
  requesterX = requesterX ?? useRequesterStore()

  return requesterX.Put({
    route: '/user/update',
    withAuth: true,
    body: {
      name: user.name,
      fullname: user.fullname,
      phone: user.phone,
    },
  })
}

export function isUserProfileComplete(user: any): boolean {
  return true
  //Temporalmente suspendido porque no hay logica alternativa de completar el registro porque los datos son opcionales
  //A menos que en el onboarding agrege el nombre y apellido opcional, pero serian 4 pantallas
  if (!user) {
    return false
  }
  const firstName = String(user.name ?? '').trim()
  const lastName = String(user.fullname ?? '').trim()
  const phone = String(user.phone ?? user.telephone ?? '').trim()
  return firstName.length > 0 && lastName.length > 0 && /^09\d{8}$/.test(phone)
}
export async function getIdentificationTypes() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/customer/identification-types`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getClientByCedula(cedulaCliente: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/customer/search/${cedulaCliente}`,
      withAuth: true,
    })
    const data = resp.data
    return resp.data
  } catch (e) {
    throw e
  }
}
/*
export async function checkUser() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/user/validate`,
      withAuth: true,
    })
    const data = resp.data

    return resp.data
  } catch (e) {
    throw e
  }
}
*/
/*
export async function getCurrentUser() {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Get({
    route: `/auth/me`,
    withAuth: true,
  })
}
*/
export async function getCurrentUser() {
  requesterX = requesterX ?? useRequesterStore()

  const response = await requesterX.Get({
    route: '/auth/me',
    withAuth: true,
  })

  return response
}
export async function validateEmailAPI(email: string) {
  try {
    const requesterX = useRequesterStore()
    const resp = await requesterX.Post({
      route: `/user/validate-email`,
      withAuth: false,
      body: {
        email,
      },
      extraHeader: {
        isPublic: true,
      },
    })

    return resp
  } catch (e) {
    throw e
  }
}
